import {APPEAL_ENABLED, IS_LOCAL_DEV} from "src/app/config/EnvConfig";
import {StringUtil} from "src/app/util/StringUtil";
export const EMPTY_STR = "";

export const isDev = () => {
    // use ENV config when running on non-dev env
    if (!StringUtil.isNullOrEmpty(IS_LOCAL_DEV) && IS_LOCAL_DEV.indexOf("{{") == -1) {
        return IS_LOCAL_DEV.toString().toLowerCase() === 'true';
    }
    // for local dev unit test
    return process.env.IS_DEV?.toLowerCase() === 'true'
};

export const isAppealEnable = () => {
    // use ENV config when running on non-dev env
    if (!StringUtil.isNullOrEmpty(APPEAL_ENABLED) && APPEAL_ENABLED.indexOf("{{") == -1) {
        return APPEAL_ENABLED.toString().toLowerCase() === 'true';
    }
    // for local dev unit test
    return process.env.APPEAL_ENABLED?.toLowerCase() === 'true'
}

export const DEFAULT_PAGE_SIZE = 10;
